import { DialogTitle,DialogActions,DialogContent,Button  } from '@mui/material';
import "./ConfirmationDialog.scss";
import { cancelSubscription } from '../../utils/services/user';




function ConfirmationDialog({setConfirmationDialog,selectedPlan}: {
    setConfirmationDialog: (value: boolean) => void; 
    selectedPlan: any;
  }) {

  return (
    <div className="confirmationDialog">
      <DialogTitle>{"Confirm Cancellation"}</DialogTitle>
      <DialogContent>
          <p>
          Are you sure you want to cancel your subscription?
          </p>
          <p>
          Canceling may result in losing access to premium features and your data. <br /> To retain your data and benefits, consider keeping your subscription active.
          </p>
          <DialogActions
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0rem",
              }}
            >
                <p style={{ cursor: 'pointer', fontWeight: 'normal', textDecoration: 'underline' }} onClick={()=>{
                    cancelSubscription(selectedPlan,setConfirmationDialog)
                }}>Cancel Subscription</p>
                &nbsp;
              <Button style={{fontSize:'0.9rem',padding:'5px 15px', textTransform:'capitalize'}}
              onClick={()=>{setConfirmationDialog(false)}}
              >{`Keep Subscription`}</Button>
            </DialogActions>
        </DialogContent>
  
    </div>
  );
}

export default ConfirmationDialog;